export interface PresentationDeckSlide {
  readonly id: string;
  readonly title: string;
  readonly body: readonly string[];
  readonly code?: string;
  readonly notes?: string;
}

export function PresentationDeck(props: {
  readonly slide: PresentationDeckSlide;
  readonly index: number;
  readonly total: number;
  readonly showNotes?: boolean;
  readonly showCount?: boolean;
  readonly hideCode?: boolean;
  readonly className?: string;
}) {
  const { slide, index, total, showNotes, showCount = true, hideCode = false, className } = props;
  return (
    <article className={["presentation-deck-slide", className ?? ""].filter(Boolean).join(" ")}>
      {showCount ? (
        <p className="presentation-deck-count muted small">
          Slide {index + 1} of {total}
        </p>
      ) : null}
      <h2 className="presentation-deck-title">{slide.title}</h2>
      <div className="presentation-deck-body">
        {slide.body.map((para, i) => (
          <p key={`${slide.id}-p-${i}`}>{para}</p>
        ))}
      </div>
      {!hideCode && slide.code ? (
        <pre className="presentation-deck-code">
          <code>{slide.code}</code>
        </pre>
      ) : null}
      {showNotes && slide.notes ? (
        <aside className="presentation-deck-notes">
          <p className="presentation-deck-notes-label">Speaker notes</p>
          <p>{slide.notes}</p>
        </aside>
      ) : null}
    </article>
  );
}

export function PresentationDeckNav(props: {
  readonly index: number;
  readonly total: number;
  readonly onPrev: () => void;
  readonly onNext: () => void;
  readonly nextLabel?: string;
}) {
  const { index, total, onPrev, onNext, nextLabel } = props;
  const atStart = index <= 0;
  const atEnd = index >= total - 1;
  return (
    <div className="presentation-deck-nav">
      <button type="button" className="btn secondary" disabled={atStart} onClick={onPrev}>
        Previous
      </button>
      <button type="button" className="btn primary" onClick={onNext}>
        {atEnd ? nextLabel ?? "Done" : "Next"}
      </button>
    </div>
  );
}
